<template>

  <head>

    <meta charset="utf-8" />
    <title>Revenue Collection Report | County Management System</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Revenue management system" name="description" />
    <meta content="County Revenue System" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />

  </head>

  <body @contextmenu.prevent data-sidebar="dark">


  <!-- Begin page -->
  <div id="layout-wrapper">



    <NavigationBar/>

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div id="content" class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <div>
                  <h4 class="mb-sm-0 font-size-18">Revenue Collection Report</h4>
                  <p class="text-muted mb-0">Period: {{formatDate(dateFrom)}} to {{formatDate(dateTo)}}</p>
                </div>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a @click="gotTo('dashboard')" href="javascript: void(0)">Dashboard</a></li>
                    <li class="breadcrumb-item"><a  href="javascript: void(0)">Reports</a></li>
                    <li class="breadcrumb-item active">Revenue by Sub County</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- Summary Cards -->
          <div class="row mb-4">
            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Total Collection</span>
                      <h4 class="mb-3">
                        <span class="counter-value">KES {{numberFormat(totalAmount)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-primary">
                        <span class="avatar-title rounded-circle bg-primary">
                          <i class="bx bx-money font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Total Transactions</span>
                      <h4 class="mb-3">
                        <span class="counter-value">{{numberFormat(totalTransactions)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-success">
                        <span class="avatar-title rounded-circle bg-success">
                          <i class="bx bx-receipt font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Sub Counties</span>
                      <h4 class="mb-3">
                        <span class="counter-value">{{numberFormat(subCountiesRevenue.length)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-info">
                        <span class="avatar-title rounded-circle bg-info">
                          <i class="bx bx-map font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Average per Transaction</span>
                      <h4 class="mb-3">
                        <span class="counter-value">KES {{getAverageTransaction()}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-warning">
                        <span class="avatar-title rounded-circle bg-warning">
                          <i class="bx bx-trending-up font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white border-bottom">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <h5 class="card-title mb-0">Sub County Collections</h5>
                    </div>
                    <div class="col-md-6">
                      <div class="d-flex justify-content-end gap-2">
                        <button @click="refreshData()" type="button" class="btn btn-outline-primary btn-sm" :disabled="loading">
                          <i class="bx bx-refresh" :class="{'bx-spin': loading}"></i>
                          {{ loading ? 'Refreshing...' : 'Refresh' }}
                        </button>
                        <button @click="downloadCSV()" type="button" class="btn btn-success btn-sm" :disabled="subCountiesRevenue.length === 0">
                          <i class="bx bx-download"></i> Download CSV
                        </button>
                        <button v-if="getRight('DOWNLOAD SUB COUNTY REPORT')" @click="downloadReport()" type="button" class="btn btn-primary btn-sm">
                          <i class="bx bx-download"></i> Download Report
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-md-4">
                      <div class="search-box">
                        <div class="position-relative">
                          <input v-model="search" type="text" class="form-control" placeholder="Search sub counties..." />
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-8">
                      <div class="d-flex justify-content-end gap-2">
                        <div class="d-flex align-items-center">
                          <label class="form-label mb-0 me-2">From:</label>
                          <input v-model="dateFrom" class="form-control form-control-sm" type="date" style="width: auto;">
                        </div>
                        <div class="d-flex align-items-center">
                          <label class="form-label mb-0 me-2">To:</label>
                          <input v-model="dateTo" class="form-control form-control-sm" type="date" style="width: auto;">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body p-0">
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary mb-3" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <h5>Loading Data...</h5>
                    <p class="text-muted">Please wait while we fetch the latest revenue data.</p>
                  </div>

                  <div v-else-if="subCountiesRevenue.length === 0" class="text-center py-5">
                    <div class="py-4">
                      <i class="bx bx-search-alt-2 font-size-96 text-muted"></i>
                      <h4 class="mt-3">No Results Found</h4>
                      <p class="text-muted">No revenue data found for the selected criteria. Try adjusting your search or date range.</p>
                      <button @click="clearFilters()" class="btn btn-outline-primary">Clear Filters</button>
                    </div>
                  </div>

                  <div v-else class="table-responsive">
                    <table class="table table-hover align-middle mb-0">
                      <thead class="table-dark">
                      <tr>
                        <th class="text-center" style="width: 60px;">#</th>
                        <th>Sub County</th>
                        <th class="text-end">Today's Amount</th>
                        <th class="text-end">Total Amount</th>
                        <th class="text-center" style="width: 120px;">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in paginatedData" :key="item.subCountyID" class="position-relative">
                        <td class="text-center">
                          <span class="badge bg-light text-dark rounded-pill">{{getItemNumber(index)}}</span>
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="me-3">
                              <div class="avatar-xs">
                                <span class="avatar-title rounded bg-primary-subtle text-primary">
                                  {{getInitials(item.subCountyName)}}
                                </span>
                              </div>
                            </div>
                            <div>
                              <h6 class="mb-0">
                                <a href="javascript:void(0);" @click="gotTo('reports-sub-counties-details',item)"
                                   class="text-decoration-none">{{formatSubCountyName(item.subCountyName)}}</a>
                              </h6>
                              <small class="text-muted">ID: {{item.subCountyID}}</small>
                            </div>
                          </div>
                        </td>
                        <td class="text-end">
                          <div class="d-flex flex-column align-items-end">
                            <span class="fw-bold text-success mb-1">KES {{numberFormat(item.todayAmount)}}</span>
                            <div class="d-flex align-items-center" style="width: 120px;">
                              <div class="progress flex-grow-1 me-2" style="height: 8px;">
                                <div class="progress-bar bg-success"
                                     :style="`width: ${getPercentageOfTotal(item.todayAmount)}%`">
                                </div>
                              </div>
                              <small class="text-muted" style="min-width: 35px;">{{getPercentageOfTotal(item.todayAmount)}}%</small>
                            </div>
                          </div>
                        </td>
                        <td class="text-end">
                          <span class="fw-medium">KES {{numberFormat(item.totalAmount)}}</span>
                        </td>
                        <td class="text-center">
                          <button @click="gotTo('reports-sub-counties-details',item)"
                                  class="btn btn-primary btn-sm">
                            <i class="bx bx-show me-1"></i> View
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="card-footer bg-light" v-if="subCountiesRevenue.length > 0">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <div class="d-flex align-items-center gap-2">
                        <span class="text-muted">Show</span>
                        <select class="form-select form-select-sm" v-model="pageSize" style="width: auto;">
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                        <span class="text-muted">entries</span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <nav aria-label="Page navigation">
                        <ul class="pagination pagination-sm justify-content-end mb-0">
                          <li class="page-item" :class="{ disabled: currentPage === 1 }">
                            <a class="page-link" @click="prevPage" :disabled="currentPage === 1">
                              <i class="bx bx-chevron-left"></i>
                            </a>
                          </li>
                          <li v-for="page in pagination(currentPage, totalPages, 3)" :key="page"
                              class="page-item" :class="{ active: currentPage === page }">
                            <span v-if="page === '...'" class="page-link">{{ page }}</span>
                            <a v-else class="page-link" @click="goToPage(page)">{{ page }}</a>
                          </li>
                          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                            <a class="page-link" @click="nextPage" :disabled="currentPage === totalPages">
                              <i class="bx bx-chevron-right"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>

                  <!-- Summary Row -->
                  <div class="row mt-3 pt-3 border-top">
                    <div class="col-12">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <strong>Total: {{numberFormat(subCountiesRevenue.length)}} Sub Counties</strong>
                        </div>
                        <div class="text-end">
                          <div><strong>Today: KES {{numberFormat(totalTodayAmount)}}</strong></div>
                          <div class="text-success"><strong>Total: KES {{numberFormat(totalAmount)}}</strong></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">©County Revenue System</div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Developed by County IT Department
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->

  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>

  </body>

</template>

<script>
/* eslint-disable */
import moment from 'moment'
import {biller, execute, executeDownload, getRight} from "@/api";
import NavigationBar from "@/components/Navigation";
import router from "@/router";

export default {
  name: "SubCountyReport",
  components: {NavigationBar},
  data() {
    return {
      subCountyName:"",
      documentType:"pdf",

      loading: false,
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      totalItems:0,

      search:"",

      totalAgents:0,
      totalTransactions:0,
      totalTodayAmount:0,
      dateRange:'',
      dateTo:'',
      dateFrom:'',
      names:'',
      totalAmount:null,
      subCountiesRevenue: [],
    };
  },
  watch: {
    pageSize(newPageSize) {
      // Don't call API, just recalculate pagination for current data
      this.totalPages = Math.ceil(this.filteredData.length / newPageSize);
      this.currentPage = 1;
    },

    search(){
      this.currentPage = 1;
      // Update total pages based on filtered data
      this.totalPages = Math.ceil(this.filteredData.length / this.pageSize);
    },
  },
  computed:{
    startIndex() {
      return (this.currentPage - 1) * this.pageSize;
    },
    endIndex() {
      return this.currentPage * this.pageSize;
    },
    // Filter data based on search
    filteredData() {
      if (!this.search) {
        return this.subCountiesRevenue;
      }
      return this.subCountiesRevenue.filter(item => {
        const name = this.formatSubCountyName(item.subCountyName).toLowerCase();
        return name.includes(this.search.toLowerCase());
      });
    },
    // Paginate the filtered data
    paginatedData() {
      return this.filteredData.slice(this.startIndex, this.endIndex);
    }
  },
  mounted() {
    this.dateFrom = moment().format('YYYY-MM-DD')
    this.dateTo = moment().format('YYYY-MM-DD')

    this.$watch('dateFrom', function (newValue) {
      if (this.dateFrom === '' || this.dateTo === '') {
        return;
      } else {
        this.currentPage = 1;
        this.getSubCountiesRevenue()
      }
    })

    this.$watch('dateTo', function (newValue) {
      if (this.dateFrom === '' || this.dateTo === '') {
        return;
      } else {
        this.currentPage = 1;
        this.getSubCountiesRevenue()
      }
    })

    this.getSubCountiesRevenue()
    this.menuAccess()
  },
  methods: {
    menuAccess(){
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Reports Sub County");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));
      execute(data,biller)
          .then((res) => {
            // Success
          })
          .catch((e) => {
            console.error("Menu access error:", e);
          });
    },

    getRight(type){
      return getRight(type)
    },

    // Helper methods for better UX
    getInitials(name) {
      if (!name || name === 'undefined') return '?';
      return name.split(' ').map(word => word.charAt(0)).join('').substring(0, 2).toUpperCase();
    },

    formatSubCountyName(name) {
      if (!name || name === 'undefined') return 'Unknown';
      return name.toLowerCase().split(' ').map(word =>
          word.charAt(0).toUpperCase() + word.slice(1)
      ).join(' ');
    },

    getItemNumber(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    },

    getPercentageOfTotal(amount) {
      if (this.totalTodayAmount === 0) return 0;
      return ((amount / this.totalTodayAmount) * 100).toFixed(1);
    },

    getAverageTransaction() {
      if (this.totalTransactions === 0) return '0';
      return this.numberFormat(Math.round(this.totalAmount / this.totalTransactions));
    },

    refreshData() {
      this.getSubCountiesRevenue();
    },

    clearFilters() {
      this.search = '';
      this.dateFrom = moment().format('YYYY-MM-DD');
      this.dateTo = moment().format('YYYY-MM-DD');
      this.currentPage = 1;
      this.getSubCountiesRevenue();
    },

    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) {
          end = totalPages;
        }
      }
      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) {
          start = 1;
        }
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) {
        pages.unshift("...");
      }
      if (end < totalPages) {
        pages.push("...");
      }

      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
      }
    },

    formatDate(date) {
      let d = new Date(date);
      let day = d.getDate();
      let month = d.toLocaleString('en-US', { month: 'short' });
      let year = d.getFullYear();

      let suffix = '';
      if (day % 10 === 1 && day !== 11) {
        suffix = 'st';
      } else if (day % 10 === 2 && day !== 12) {
        suffix = 'nd';
      } else if (day % 10 === 3 && day !== 13) {
        suffix = 'rd';
      } else {
        suffix = 'th';
      }
      return `${day}${suffix} ${month} ${year}`;
    },

    // New CSV download method that uses current displayed data
    downloadCSV() {
      // Prepare CSV content
      let csvContent = [];

      // Add headers
      csvContent.push([
        'Sub County ID',
        'Sub County Name',
        "Today's Amount (KES)",
        'Total Amount (KES)',
        'Percentage of Today\'s Total'
      ].join(','));

      // Add data rows - use the currently displayed/filtered data
      this.filteredData.forEach((item) => {
        const row = [
          item.subCountyID,
          `"${this.formatSubCountyName(item.subCountyName)}"`, // Quote in case of commas
          item.todayAmount || 0,
          item.totalAmount || 0,
          `${this.getPercentageOfTotal(item.todayAmount)}%`
        ];
        csvContent.push(row.join(','));
      });

      // Add summary section
      csvContent.push(''); // Empty row
      csvContent.push('SUMMARY');
      csvContent.push(`Total Sub Counties,${this.filteredData.length}`);
      csvContent.push(`Today's Total Amount (KES),${this.totalTodayAmount || 0}`);
      csvContent.push(`Grand Total Amount (KES),${this.totalAmount || 0}`);
      csvContent.push(`Average per Transaction (KES),${this.totalTransactions > 0 ? Math.round(this.totalAmount / this.totalTransactions) : 0}`);
      csvContent.push(`Report Period,"${this.formatDate(this.dateFrom)} to ${this.formatDate(this.dateTo)}"`);
      csvContent.push(`Generated On,"${moment().format('YYYY-MM-DD HH:mm:ss')}"`);

      // Convert to blob and download
      const csvString = csvContent.join('\n');
      const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      link.setAttribute('href', url);
      link.setAttribute('download', `SubCounty_Revenue_Report_${moment().format('YYYY-MM-DD_HHmmss')}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    // Original download report method (if needed for other purposes)
    downloadReport() {
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += "Sub County,Today's Amount,Total Amount,Percentage of Today's Total\n";

      this.subCountiesRevenue.forEach((item) => {
        const percentage = this.getPercentageOfTotal(item.todayAmount);
        csvContent += `"${this.formatSubCountyName(item.subCountyName)}",${item.todayAmount},${item.totalAmount},${percentage}%\n`;
      });

      csvContent += `\nSUMMARY,,\n`;
      csvContent += `Total Sub Counties,${this.subCountiesRevenue.length},\n`;
      csvContent += `Today's Total Amount,${this.totalTodayAmount},\n`;
      csvContent += `Grand Total Amount,${this.totalAmount},\n`;

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `Revenue_Report_${this.dateFrom}_to_${this.dateTo}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    gotTo(route,item) {
      sessionStorage.setItem("currentPage",route)
      sessionStorage.setItem("dateTo", this.dateTo)
      sessionStorage.setItem("dateFrom", this.dateFrom)
      sessionStorage.setItem("subCountyName", item.subCountyName)
      sessionStorage.setItem("subCountyID", item.subCountyID)
      sessionStorage.setItem("totalTransactions", item.totalTransactions || 0)
      sessionStorage.setItem("amountTotal", item.totalAmount)
      sessionStorage.setItem("todayAmount", item.todayAmount)
      sessionStorage.setItem("totalAgents", item.totalAgents || 0)
      sessionStorage.setItem("totalZones", item.totalZones || 0)
      router.push(route)
    },

    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num)
    },

    getSubCountiesRevenue() {
      this.loading = true
      this.subCountiesRevenue = []
      this.totalTransactions = 0
      this.totalAmount = 0
      this.totalTodayAmount = 0
      this.totalAgents = 0

      const data = new FormData();
      data.append("function", "getSubCountiesRevenue");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      // Remove pagination params - get all data
      // data.append("page", this.currentPage);
      // data.append("rows_per_page", this.pageSize);
      // Remove search from API call - we'll filter client-side
      // data.append("keyword", this.search);

      execute(data, biller)
          .then((res) => {
            this.loading = false
            if (res.data.success) {
              this.subCountiesRevenue = res.data.data.subCountiesRevenue || [];

              // Calculate totals from the actual data
              this.totalAmount = this.subCountiesRevenue.reduce((acc, cur) => {
                let amount = Number(cur.totalAmount);
                if (!isNaN(amount)) {
                  return acc + amount;
                } else {
                  return acc;
                }
              }, 0);

              this.totalTodayAmount = this.subCountiesRevenue.reduce((acc, cur) => {
                let amount = Number(cur.todayAmount);
                if (!isNaN(amount)) {
                  return acc + amount;
                } else {
                  return acc;
                }
              }, 0);

              // Calculate total transactions (sum of all transactions from sub-counties)
              this.totalTransactions = this.subCountiesRevenue.reduce((acc, cur) => {
                let transactions = Number(cur.totalTransactions) || 0;
                return acc + transactions;
              }, 0);

              // Set pagination based on filtered data
              this.totalItems = this.filteredData.length;
              this.totalPages = Math.ceil(this.totalItems / this.pageSize);

            } else {
              console.log("API returned success: false", res.data.message);
            }
          })
          .catch((e) => {
            this.loading = false;
            console.error("API Error:", e);
            alert("Failed to load data. Please check your connection and try again.");
          });
    },
  },
}
</script>

<style scoped>
.card-h-100 {
  height: 100%;
}

.search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #74788d;
}

.table-hover tbody tr:hover {
  background-color: #f8f9fa;
}

.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 12px;
  font-weight: 600;
}

.bg-primary-subtle {
  background-color: rgba(13, 110, 253, 0.1) !important;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.bx-spin {
  animation: spin 1s linear infinite;
}

.page-link {
  cursor: pointer;
}

.page-item.disabled .page-link {
  cursor: not-allowed;
}

.btn-success {
  background-color: #34c38f;
  border-color: #34c38f;
}

.btn-success:hover {
  background-color: #2fa97c;
  border-color: #2fa97c;
}
</style>